export function searchFilterOrders(
  orders,
  searchTerm,
  statusFilter = "All",
  salesChannelFilter = "All"
) {
  if (!Array.isArray(orders) || orders.length === 0) return [];

  const term = (searchTerm || "")
    .replace(/[^a-zA-Z0-9\s\-_.@]/g, "")
    .replace(/\s+/g, " ")
    .trim()
    .toLowerCase();

  return orders.filter((order) => {
    const orderNumber = order.orderNumber?.toLowerCase();
    const orderId = order.id?.toLowerCase();
    const customerName = order.customer?.name?.toLowerCase();
    const customerEmail = order.customer?.email?.toLowerCase();

    const matchesSearch =
      !term ||
      (orderNumber && orderNumber.includes(term)) ||
      (orderId && orderId.includes(term)) ||
      (customerName && customerName.includes(term)) ||
      (customerEmail && customerEmail.includes(term));

    const matchesStatus =
      statusFilter === "All" ||
      order.orderStatus?.toLowerCase() === statusFilter.toLowerCase();

    const matchesChannel =
      salesChannelFilter === "All" ||
      order.salesChannel?.toLowerCase() === salesChannelFilter.toLowerCase();

    return matchesSearch && matchesStatus && matchesChannel;
  });
}
